var exports = {
  "wx": "x43aef4ae--e8d582--header",
  "PV": "x43aef4ae--e8d582--header_fixed",
  "zN": "x43aef4ae--e8d582--header__wrapper",
  "Lg": "x43aef4ae--e8d582--navigation",
  "ke": "x43aef4ae--e8d582--navigation__logo",
  "NH": "x43aef4ae--e8d582--header__contacts",
};

module.exports = exports;
